<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataCleaners")
    template(v-if="$route.name === 'DataCleanerNew'")
      b-icon(icon="user")
      h1.title Neue Reinigungsfirma
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'DataCleanerEdit' && formData.id")
      h1.title Reinigungsfirma \#{{formData.id}}
      .sub-headline Zuletzt bearbeitet am {{formatDate(formData.updatedAt)}} Uhr
  
    .guest-wrapper.margin-top
      .two-column
        .column
          .card
            .top
              .left
                .card-headline Daten
                .card-description Hier finden Sie den kompletten Datensatz der Reinigungsfirma.
              .right
            .main.padding
              ValidationObserver(v-slot="{ handleSubmit }")
                .form
                  h2.title.is-6 Allgemein
                  ValidationProvider(name="Firma" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Firma" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.company")

                  ValidationProvider(name="Anrede" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Anrede" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-select(v-model="formData.salutation")
                        option(value="Frau") Frau
                        option(value="Herr") Herr
                  ValidationProvider(name="Vorname" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Vorname" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.firstName")
                  
                  ValidationProvider(name="Nachname" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Nachname" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.lastName")
                  
                  ValidationProvider(name="USt - IdNr." rules="required" v-slot="{ errors, valid }") 
                    b-field(label="USt - IdNr." label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.vatId")
                  
                  ValidationProvider(name="Steuernummer" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Steuernummer" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.taxId")

                .form.margin-top
                  h2.title.is-6 Adresse
                  b-field(label="Adresszusatz" label-position="on-border")
                    b-input(v-model="formData.address.line1")
                  
                  ValidationProvider(name="Straße und HausNr." rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Straße und HausNr." label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.street")
                  
                  b-field(grouped)
                    ValidationProvider(name="PLZ" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="PLZ" label-position="on-border"
                              :type="{ 'is-danger': errors[0] }" :message="errors")
                        b-input(v-model="formData.address.zip")
                    .spacer.sm
                    ValidationProvider(name="Stadt" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Stadt" label-position="on-border"
                              :type="{ 'is-danger': errors[0] }" :message="errors")
                        b-input(v-model="formData.address.city")

                  ValidationProvider(name="Land" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Land" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.country")

                .form.margin-top
                  h2.title.is-6 Kontakt
                  ValidationProvider(name="E-Mail" rules="required|email" v-slot="{ errors, valid }") 
                    b-field(label="E-Mail" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.email")
                  ValidationProvider(name="Alternative E-Mail" rules="email" v-slot="{ errors, valid }") 
                    b-field(label="Alternative E-Mail" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.email2")
                  ValidationProvider(name="Mobiltelefon" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Mobiltelefon" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.mobile")
                  ValidationProvider(name="Telefon" rules="" v-slot="{ errors, valid }") 
                    b-field(label="Telefon" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.phone")
                  ValidationProvider(name="Telefax" rules="" v-slot="{ errors, valid }") 
                    b-field(label="Telefax" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.address.fax")

                .form.margin-top
                  h2.title.is-6 Bankdaten
                  ValidationProvider(name="Kontoinhaber" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Kontoinhaber" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.accountOwner")
                  ValidationProvider(name="Bank" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Bank" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.bankName")
                  ValidationProvider(name="IBAN" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="IBAN" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.iban")
                  ValidationProvider(name="BIC" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="BIC" label-position="on-border"
                            :type="{ 'is-danger': errors[0] }" :message="errors")
                      b-input(v-model="formData.bic")

                .form.margin-top
                  b-field(label="Kommentar zum Eigentümer" label-position="on-border")
                    b-input(type="textarea" v-model="formData.comment")

                .button-wrapper.margin-top.right
                  b-button(type="is-light" @click="$router.push({name: 'DataCleaners'})") Abbrechen
                  b-button(type="is-primary" @click="handleSubmit(updateCleaner)") Speichern
          
        .column
          .card
            .top
              .left
                .card-headline Objekte
                .card-description Hier finden Sie alle Objekte der Reinigungsfirma.
              .right
            .main.padding
              b-table(:data="formData.rentObjects"
                default-sort-direction="asc"
                default-sort="date"
                hoverable
                @click="row => $router.push('/data/rent-objects/edit/'+row.id)")
                b-table-column(field='thumbnail' label='Vorschau' v-slot="props")
                  img(:src="props.row.rentObjectImages[0].thumbnailUrl")
                b-table-column(field='name' label='Mietobjekt' sortable v-slot="props")
                  .r-name {{ props.row.name }}

</template>

<script>
import {DateTime} from "luxon"

export default {
  components: {
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      cleaner: null,
      formData: {
        company: null,
        salutation: null,
        firstName: null,
        lastName: null,
        taxId: null,
        vatId: null,
        bankName: null,
        accountOwner: null,
        iban: null,
        bic: null,
        comment: "",
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          phone: null,
          mobile: null,
          fax: null
        }
      }
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();

    if (this.$route.name !== "DataCustomerNew" && this.id) {
      this.cleaner = await this.$store.dispatch("cleaners/findOne", { id: this.id });
      this.formData = {
        ...this.formData,
        ...this.cleaner
      };
    }
    loadingComponent.close();
  },
  methods: {
    async updateCleaner() {
      // With rentObjects Parameter the request is way to big
      // eslint-disable-next-line no-unused-vars
      const { rentObjects, ...withoutRentObjects } = this.formData;
      if (this.id) {
        await this.$store.dispatch("cleaners/update", withoutRentObjects);
      } else {
        const newCleaner = await this.$store.dispatch("cleaners/create", withoutRentObjects);
        this.$router.push({ name: "DataCleanerEdit", params: { id: newCleaner.id } });
      }
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    simpleDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.status-wrapper {
  margin-top: $xs-space;
}

.button-wrapper {
  margin: $xs-space 0 $sm-space 0;
}
.two-column {
  display: flex;
  justify-content: space-between;
}
.r-name {
  font-weight: 500;
}
.label {
  font-weight: 600;
  margin-top: $sm-space;
  margin-bottom: 0;
  &:not(:last-child) {
    margin-bottom: 0;
  }
}
</style>